import React from 'react'
import { useGetLeadQuotationQuery } from '../../../Services/campign/CampaignDetail';
import { useParams } from 'react-router-dom';

const QuotationList = ({ setPaneOpen, ticket }: any) => {
    const { uuid } = useParams();
    const { data, isLoading } = useGetLeadQuotationQuery(uuid);

    console.log(data, "data");
    return (
        <>
            <div className="d-flex flex-column">
                {ticket?.status_display !== "Rejected" && (
                    <div className="ms-auto mt-2 mb-2 mx-">
                        <button className="btn btn-primary me-2" onClick={() => setPaneOpen("LeadInformationTab")}>
                            Create quotation
                        </button>

                    </div>
                )}

                <div
                    className="card p-2 my-1 d-flex flex-column"
                    style={{
                        maxHeight: "300px",
                        height: "100%",
                        overflowX: "hidden",
                        overflowY: "auto",
                    }}
                >
                    {/* Header Row */}
                    <div
                        className="d-flex bg-light p-2 border-bottom"
                        style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                        <div
                            style={{
                                flex: 1,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            S.No.
                        </div>
                        <div
                            style={{
                                flex: 2,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            Created date
                        </div>
                        <div
                            style={{
                                flex: 2,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            Version
                        </div>
                        <div
                            style={{
                                flex: 3,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                whiteSpace: 'normal',
                                fontSize: 13,
                                wordBreak: 'break-all',
                                minWidth: 0,
                                maxWidth: 200,
                                height: '100%',
                                minHeight: 40,
                            }}
                        >
                            Updates
                        </div>
                        <div
                            style={{
                                flex: 2,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            Download quotation
                        </div>
                    </div>
                    {/* Data Rows */}
                    {isLoading ? (
                        <div style={{ textAlign: 'center', padding: 20 }}>Loading...</div>
                    ) : data?.results?.length > 0 ? (
                        data.results.map((item: any, idx: number) => (
                            <div
                                key={item.id}
                                className="d-flex p-2 border-bottom"
                                style={{ textAlign: "center" }}
                            >
                                <div style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>{idx + 1}</div>
                                <div style={{ flex: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>{new Date(item.created).toLocaleString()}</div>
                                <div style={{ flex: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    {`v${data?.results?.length - idx}.0`}
                                </div>
                                <div
                                    style={{
                                        flex: 3,
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        whiteSpace: 'normal',
                                        fontSize: 13,
                                        wordBreak: 'break-all',
                                        minWidth: 0,
                                        maxWidth: 200,
                                        height: '100%',
                                    }}
                                    title={idx !== 0 && item.updates && Object.keys(item.updates).length > 2
                                        ? Object.entries(item.updates)
                                            .map(([key, value]) => `${key}: ${typeof value === 'string' ? value : JSON.stringify(value)}`)
                                            .join('\n')
                                        : undefined}
                                >
                                    {(data?.results?.length - idx === 1) ? (
                                        <span style={{ color: '#999' }}>-</span>
                                    ) : item.updates && Object.keys(item.updates).length > 0 ? (
                                        <>
                                            {Object.entries(item.updates).slice(0, 2).map(([key, value]) => {
                                                const strValue = typeof value === 'string' ? value : JSON.stringify(value);
                                                const shouldTruncate = strValue.length > 18;
                                                const displayValue = shouldTruncate ? strValue.slice(0, 15) + '...' : strValue;
                                                return (
                                                    <div
                                                        key={key}
                                                        style={{
                                                            marginBottom: 2,
                                                            width: "100%",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            textAlign: "center",
                                                        }}
                                                        title={shouldTruncate ? strValue : undefined}
                                                    >
                                                        <strong>{key}:</strong> {displayValue}
                                                    </div>
                                                );
                                            })}
                                            {Object.entries(item.updates).length > 2 && (
                                                <div style={{ color: '#666', textAlign: 'center' }}>...</div>
                                            )}
                                        </>
                                    ) : (
                                        <span style={{ color: '#999' }}>-</span>
                                    )}
                                </div>
                                <div style={{ flex: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <a href={item.quotation_url} target="_blank" rel="noopener noreferrer" download>
                                        Download
                                    </a>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div style={{ textAlign: 'center', padding: 20 }}>No quotations found.</div>
                    )}
                </div>
            </div>

        </>

    )
}

export default QuotationList
